<template src="./Invoice.html"></template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Companies from "../../../components/Forms/Companies/Companies";
import {
  getInvoiceCompanies,
  getInvoiceCompany,
  createInvoice,
  recalculateProcess,
} from "../../../services";
import {
  formatDateUTC,
  getStatusServiceChip,
  getServiceStatus,
  getInvoiceConcept,
} from "../../../utils/computeds";
import { isNumber } from "../../../utils";
import { SERVICE_STATUS } from "../../../utils/constants";
import SubClients from "../../../components/Forms/SubClients/SubClients";

export default {
  name: "Invoice",
  components: { Companies, SubClients },
  data: () => ({
    SERVICE_STATUS,
    search: {
      companyId: null,
      finalizedAt: [],
    },
    skip: 0,
    take: 100,
    companies: [],
    processes: [],
    companyActive: null,
    invoice: {
      date: null,
      number: null,
      total: null,
      processes: [],
      observation: null,
    },
    services: [],
    calcInvoice: {
      services: 0,
      extras: 0,
      total: 0,
    },
    panels: [],
    checkedAll: false,
    menu: false,
    dialog: false,
    dateModal: false,
    company: null,
  }),
  validations() {
    return {
      invoice: {
        date: { required },
        number: { required },
        total: { required },
      },
    };
  },
  created() {
    this.searchInvoiceCompanies();
  },
  methods: {
    isNumber,
    reset() {
      this.invoice = {
        date: moment().utc().format("YYYY-MM-DD"),
        number: null,
        total: null,
        processes: [],
        observation: null,
      };
      this.panels = [];
      this.calcInvoice = {
        services: 0,
        extras: 0,
        total: 0,
      };
      this.checkedAll = false;
      this.dialog = false;
    },
    async searchInvoiceCompanies() {
      try {
        this.companies = await getInvoiceCompanies(
          this.search.companyId,
          this.skip,
          this.take
        );
        if (this.companies.length) this.selectCompany(this.companies[0]);
      } catch (err) {
        console.log("search Invoice Companies:", err);
      }
    },
    async getCompanyInvoice(companyId) {
      try {
        const startDate = this.search.finalizedAt?.[0] || null;
        const endDate = this.search.finalizedAt?.[1] || null;
        const subClientId = this.search.subClientId || null;

        this.processes = await getInvoiceCompany(companyId, startDate, endDate,subClientId);
      } catch (err) {
        console.log("get Company Invoice:", err);
      }
    },
    selectCompany(company) {
      this.reset();
      this.companyActive = company;
      this.getCompanyInvoice(company.id);
      this.company = company;
    },
    seeAllProcess(quantity) {
      if (quantity === 0) this.panels = [];
      else this.panels = [...Array(quantity + 1).keys()];
    },
    calculate() {
      this.services = [];
      const services = [];
      this.calcInvoice = this.invoice.processes.reduce(
        (res, processId) => {
          const process = this.processes.find(
            (process) => process.id === processId
          );
          const { name, total } = getInvoiceConcept(process);
          services.push({ name, quantity: 1, total });

          if (process.metadata?.chargeExtraCostToClient !== false) {
            res.extras += process.extraCost;
          }
          res.services += process.total;

          return res;
        },
        { services: 0, extras: 0, total: 0 }
      );
      this.calcInvoice.total =
        this.calcInvoice.services + this.calcInvoice.extras;

      this.services = services.reduce((res, service) => {
        const index = res.findIndex((item) => item.name === service.name);
        if (index !== -1) {
          res[index].total += service.total;
          res[index].quantity += service.quantity;
        } else {
          res.push(service);
        }
        return res;
      }, []);
    },
    check(e, process) {
      e.cancelBubble = true;
      this.checkedAll = false;

      if (this.invoice.processes.includes(process.id)) {
        this.invoice.processes = this.invoice.processes.filter(
          (processId) => processId !== process.id
        );
        process.checked = false;
      } else {
        this.invoice.processes.push(process.id);
        process.checked = true;
      }
      this.calculate();
    },
    checkAll(e) {
      e.cancelBubble = true;

      if (!this.checkedAll) {
        this.invoice.processes = [];
        for (const process of this.processes) {
          process.checked = false;
        }
      } else {
        const alertCount = this.processes.filter(
          (p) => p.metadata?.hasAlert
        ).length;

        this.invoice.processes = this.processes
          .filter((p) => !p.metadata?.hasAlert)
          .map((p) => p.id);

        for (const process of this.processes) {
          process.checked = !process.metadata?.hasAlert;
        }

        if (alertCount > 0) {
          this.$swal({
            text: `${alertCount} proceso${alertCount > 1 ? "s" : ""} con alerta pendiente ${alertCount > 1 ? "fueron excluidos" : "fue excluido"} de la selección. Recalcula su total antes de facturar.`,
            buttons: false,
            icon: "warning",
            timer: 5000,
          });
        }
      }
      this.calculate();
    },
    async recalculate(process) {
      this.$set(process, "recalculating", true);
      try {
        const updated = await recalculateProcess(process.id);
        process.total = updated.total;
        if (updated.metadata) {
          this.$set(process, "metadata", updated.metadata);
        }
        if (!updated.metadata?.hasAlert) {
          this.$swal({
            text: "Total recalculado correctamente.",
            buttons: false,
            icon: "success",
            timer: 3000,
          });
        } else {
          this.$swal({
            text: "No se encontró un combo configurado. El total no fue modificado.",
            buttons: false,
            icon: "warning",
            timer: 4000,
          });
        }
        this.calculate();
      } catch (error) {
        this.$swal({
          text: error.message ?? "Ocurrió un error al recalcular, intenta más tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      } finally {
        this.$set(process, "recalculating", false);
      }
    },
    async saveInvoice() {
      try {
        await createInvoice(this.invoice);
        await this.searchInvoiceCompanies();

        this.$swal({
          text: "Se creo la factura.",
          buttons: false,
          icon: "success",
          timer: 3000,
        });
        this.reset();
      } catch (error) {
        console.log("Error on create invoice =>", error);
        this.$swal({
          text: error.message ?? "Ocurrio un error, intenta mas tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    },
  },
  computed: {
    formatDateUTC,
    getStatusServiceChip,
    getServiceStatus,
  },
};
</script>
<style lang="scss" scoped src="./Invoice.scss"></style>
